import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
// Nested under the WeekPlanner key so every place that invalidates the task list refreshes these
// totals too — they change on exactly the same mutations.
export const weekPlannerPlannedMinutesQueryKey = [TaskQueryKey.WeekPlanner, 'plannedMinutes'];
export const useGetWeekPlannerPlannedMinutes = (params) => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([...weekPlannerPlannedMinutesQueryKey, params], () => api.base
        .get(`${config.appUrls.tasks}/api/WeekPlanner/PlannedMinutes`, { params })
        .then(res => res.data), {
        enabled: !!params.userId && !!params.executionDateFrom && !!params.executionDateUntil,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
